<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
  >
    <template #pic>
      <div
        v-if="isCompleted"
        class="label-pic is-green"
      >
        <icon
          data="@icon/task-breakdown.svg"
          class="label-pic__icon"
          :fill="true"
          color="var(--markingGreen-02)"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
      <div
        v-else
        class="label-pic is-orange"
      >
        <icon
          data="@icon/task-breakdown.svg"
          class="label-pic__icon"
          :fill="true"
          color="var(--markingOrange-02)"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        {{ title }}
        <span
          v-if="showInitiator"
          class="notification__todo-title-by"
        >
          by
        </span>
        <span
          v-if="showInitiator"
          class="notification__update-item__initiator"
        >
          {{ notification.initiatorFullName }}
        </span>
      </BaseSubHeading>
    </template>
    <template #content>
      <div class="notification__todo-details">
        <a
          class="notification__todo-details-name link"
          target="_blank"
          :href="notification.todoUrl"
        >
          <ReferencedText
            :resetStyle="true"
            :html="notification.todoName"
          />
        </a>
      </div>
      <div
        v-if="notification.hasDueDateChange"
        class="notification__todo-change"
      >
        <span
          v-if="notification.previousDueLabel"
          class="to-do__item__due notification__todo-change-previous"
          :class="{
            'is-urgent': notification.previousDueLabel === 'Urgent',
            'is-scheduled': !['Urgent', 'No Date'].includes(notification.previousDueLabel)
          }"
        >
          {{ notification.previousDueLabel }}
        </span>
        <icon
          v-if="notification.previousDueLabel && notification.dueLabel"
          data="@icon/arrow-to.svg"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="var(--monochrome-05)"
        />
        <span
          v-if="notification.dueLabel"
          class="to-do__item__due"
          :class="`is-${notification.dueStatus}`"
        >
          {{ notification.dueLabel }}
        </span>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { ReferencedText } from "@/components/Reference"

import { NotificationType } from "@/models/Notification/common"
import { NotificationTodo } from "@/models/Notification/NotificationTodo"

const props = defineProps<{
  notification: NotificationTodo
}>()

/** Matches the copy for completed and regular ToDo updates. */
const isCompleted = computed(
  () =>
    props.notification.changeActivityType === "COMPLETED" ||
    props.notification.type === NotificationType.TODO_COMPLETED
)
const title = computed(() => (isCompleted.value ? "ToDo Completed" : "ToDo Updated"))
const showInitiator = computed(
  () => !isCompleted.value && Boolean(props.notification.initiatorFullName)
)
</script>
